import { MAP_UUID_LABEL } from "../../store/common/constants";
import indoorHelper from "../../store/helpers/indoorHelper";
import translations from "../../translations/resources/en-GB.json";
export var selectDropdownList = function (qaReportExists, realm) {
    return !indoorHelper.isRealmAllowed(realm)
        ? MAP_COLLECTION_LISTITEMS
        : MAP_COLLECTION_QA_REPORT;
};
export var MAP_COLLECTION_DROPDOWN_VALUES = {
    REFRESH_COLLECTION: translations.data["venonboard.internalTools.refreshCollection"],
    DOWNLOAD_CHECKIN_REPORT: translations.data["venonboard.internalTools.downloadCheckinReport"],
    DOWNLOAD_COLLECTION: translations.data["venonboard.internalTools.downloadCollection"],
    VIEW_QA_REPORT: translations.data["venonboard.internalTools.mapCollection.viewQAReport"],
    DOWNLOAD_STUB_LINK_REPORT: translations.data["venonboard.internalTools.mapCollection.downloadStubLinkReport"],
};
export var MAP_COLLECTION_LISTITEMS = [
    translations.data["venonboard.internalTools.refreshCollection"],
    translations.data["venonboard.internalTools.downloadCheckinReport"],
    translations.data["venonboard.internalTools.downloadCollection"],
];
export var MAP_COLLECTION_QA_REPORT = [
    translations.data["venonboard.internalTools.refreshCollection"],
    translations.data["venonboard.internalTools.mapCollection.viewQAReport"],
    translations.data["venonboard.internalTools.mapCollection.downloadStubLinkReport"],
    translations.data["venonboard.internalTools.downloadCollection"],
];
export var REFRESH_COLLECTION_TOAST = {
    TITLE: translations.data["venonboard.internalTools.toastNotification.refreshTitle"],
    MESSAGE: {
        SHARED_COLLECTION: translations.data["venonboard.refreshCollection.sharedCollectionErrorMessage"],
        REFRESH_COLLECTION_SUCCESS: translations.data["venonboard.internalTools.RefreshCollectionMessage1"],
        REFRESH_COLLECTION_FAILURE: translations.data["venonboard.internalTools.RefreshCollectionMessageError"],
    },
};
export var DOWNLOAD_COLLECTION_TOAST = {
    TITLE: translations.data["venonboard.internalTools.downloadCollection"],
    MESSAGE: {
        DOWNLOAD_COLLECTION_FAILURE: translations.data["venonboard.internalTools.downloadCollectionMessageError"],
    },
};
export var DOWNLOAD_STUB_LINK_TOAST = {
    TITLE: translations.data["venonboard.internalTools.mapCollection.downloadStubLinkReport"],
    MESSAGE: {
        DOWNLOAD_STUB_LINK_FAILURE: translations.data["venonboard.internalTools.mapCollection.noReport"],
    },
};
export var VIEW_QA_REPORT_TOAST = {
    TITLE: translations.data["venonboard.internalTools.toastNotification.viewQAReport"],
    MESSAGE: {
        VIEW_QA_REPORT_FAILURE: translations.data["venonboard.internalTools.toastNotification.errorQAReport"],
    },
};
export var VIEW_CHECKIN_REPORT_TOAST = {
    TITLE: translations.data["venonboard.internalTools.downloadCheckinReport"],
    MESSAGE: {
        VIEW_CHECKIN_REPORT_FAILURE: translations.data["venonboard.internalTools.viewCheckinReportMessageError"],
    },
};
export var MAP_ORDER_TAB_LISTING = {
    ID: { LABEL: MAP_UUID_LABEL },
    NAME: {
        LABEL: "".concat(MAP_UUID_LABEL, "/").concat(translations.data["venonboard.form.migration.name"]),
    },
    CUSTOMER: { LABEL: translations.data["venonboard.mapOrders.customerTitle"] },
    ORG: { LABEL: translations.data["venonboard.mapOrders.org"] },
    TICKET: {
        LABEL: translations.data["venonboard.mapOrders.serviceTicketTitle"],
    },
};
export var MAP_COLLECTIONS_TAB_LISTING = {
    SUBHEADING: {
        LABEL: translations.data["venonboard.mapCollectionTab.subHeading"],
    },
    SHARED_COLLECTION: {
        LABEL: translations.data["venonboard.mapCollection.sharedCollectionToolTip"],
    },
    NAME: { LABEL: translations.data["venonboard.mapCollectionTab.name"] },
    COLLECTION_HRN: {
        LABEL: translations.data["venonboard.mapCollectionTab.collectionUrl"],
        DATA: translations.data["venonboard.mapCollectionTab.view"],
    },
    MAP_COUNT: {
        LABEL: translations.data["venonboard.mapCollectionTab.mapCount"],
    },
    LAST_UPDATED: {
        LABEL: translations.data["venonboard.listView.dropDown.listItem1"],
    },
};
export var CHECKED_IN_NOTIFICATION = {
    title: translations.data["venonboard.mapCheckin.notificationTitle"],
    body: translations.data["venonboard.mapCheckin.notificationBody"],
};
export var fallBackMapOrderList = {
    isLoading: true,
    mapOrderList: [],
};
export var EMPTY_MAP_ORDER_LIST = translations.data["venonboard.mapOrders.emptyList"];
export var copyIconStyle = {
    "--hds-icon-color": "var(--hds-action)",
};
export var chipStyles = {
    pointerEvents: "none",
    font: "var(--hds-caption-font-size)",
};
export var MAP_ORDER_ACTIONBUTTONS = {
    EDIT: translations.data["venonboard.mapOrders.buttonEdit"],
    CHECK_IN: translations.data["venonboard.mapOrders.checkInButton"],
};
export var MAP_ORDERS_TABLE_HEADERS = [
    {
        width: "25%",
        title: MAP_ORDER_TAB_LISTING.NAME.LABEL,
        id: "mapName",
    },
    {
        width: "20%",
        title: MAP_ORDER_TAB_LISTING.CUSTOMER.LABEL,
        id: "organizationId",
    },
    {
        width: "15%",
        title: MAP_ORDER_TAB_LISTING.ORG.LABEL,
        id: "org",
    },
    {
        width: "20%",
        title: MAP_ORDER_TAB_LISTING.TICKET.LABEL,
        id: "supportTicketNumber",
    },
    {
        width: "",
        title: "",
        id: "isCheckInDisabled",
    },
];
export var MAP_COLLECTION_TABLE_HEADERS = [
    {
        width: "3%",
        title: "",
        id: "collectionShare",
    },
    {
        width: "30%",
        title: MAP_COLLECTIONS_TAB_LISTING.NAME.LABEL,
        id: "collectionName",
    },
    {
        width: "25%",
        title: MAP_COLLECTIONS_TAB_LISTING.COLLECTION_HRN.LABEL,
        id: "collectionHrn",
    },
    {
        width: "22%",
        title: MAP_COLLECTIONS_TAB_LISTING.MAP_COUNT.LABEL,
        id: "mapCount",
    },
    {
        width: "15%",
        title: MAP_COLLECTIONS_TAB_LISTING.LAST_UPDATED.LABEL,
        id: "lastUpdated",
    },
    {
        width: "",
        title: "",
        id: "collectionDetails",
    },
];
